import { FeatureName } from 'chaika-enums';

import { featureToggleService } from '@store/Configuration/featureToggleService';

export function isPatientAppEnabled(): boolean {
    return featureToggleService.isAvailableForAuthUser(FeatureName.PatientAppInsteadOfTelegram);
}
